import { decodeHTML } from "entities";

const hasTags = (str: string) => str.includes("<");

export const removeHtmlTags = (title: string) =>
  title.replace(/<\/?[a-z]{1,6}\s?\/?>/g, "");

export const makeSimple = (str: string) => {
  const text = decodeHTML(str);
  return hasTags(text) ? removeHtmlTags(text) : text;
};

export const isEuro = (currencyCode: string) => currencyCode === "EUR";
